<template>
  <v-app id="app" :style="{ background: $vuetify.theme.themes[theme].background }" dark>
    <confirm-dialog ref="confirm"/>
    <v-snackbar v-model="snackbar" :color="color" :timeout="timeOut" multi-line top>
      {{ text }}
      <template v-slot:action>
        <template v-if="showButton">
          <v-btn
              outlined
              small
              text
              @click="
              () => {
                callback();
                snackbar = false;
              }
            "
          >
            {{ buttonText }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon @click="snackbar = false">
            <v-icon>close</v-icon>
          </v-btn>
        </template>
      </template>
    </v-snackbar>

    <v-navigation-drawer
        v-model="menuOpenState"
        :mini-variant="miniMenu && $vuetify.breakpoint.lgAndUp"
        app
        fixed

        light
        width="300"
    >
      <v-list class="pa-0" color="black" dark>
        <v-list-item style="padding-left: 9px;">
          <v-list-item-avatar class="primary" style="margin-top: 10px; margin-bottom: 10px; overflow: hidden;"
                              @click.stop="toggleMiniMenu">
            <hb-icon size="32">person</hb-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="subheading">{{ userFullName }}</v-list-item-title>
            <v-list-item-subtitle class="caption">{{ userEmail }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click.stop="toggleMiniMenu">
              <hb-icon>chevron_left</hb-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-subheader
          v-if="!this.miniMenu && filteredStrategiaPrimaryPages.length + filteredStrategiaSecondaryPages.length > 0">{{
          $t('menu_sub_headers.strategia')
        }}
      </v-subheader>
      <v-list-item
          v-for="(page, index) in filteredStrategiaPrimaryPages"
          :key="index + 'strategiaprimary'"
          :to="{ name: page.link }"
          active-class="primary--text"
      >
        <v-list-item-action>
          <hb-icon>{{ page.icon }}</hb-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title class="body-2 font-weight-bold">{{ page.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="(page, index) in filteredStrategiaSecondaryPages">
        <v-divider :key="index + 'secondary_divider'"></v-divider>
        <v-list-item
            :key="index + 'strategia_secondary'"
            :to="{ name: page.link }"
            :value="$route.name === page.link"
            active-class="primary--text"
        >
          <v-list-item-action>
            <hb-icon>{{ page.icon }}</hb-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">{{ page.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list :dense="$vuetify.breakpoint.mdAndDown">
        <v-subheader v-if="!this.miniMenu && filteredHallintaPrimaryPages.length > 0">{{
            $t('menu_sub_headers.hallinta')
          }}
        </v-subheader>
        <v-list-item
            v-for="(page, index) in filteredHallintaPrimaryPages"
            :key="index + 'hallinta_primary'"
            :to="{ name: page.link }"
            active-class="primary--text"
        >
          <v-list-item-action>
            <hb-icon>{{ page.icon }}</hb-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">{{ page.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <template v-for="(page, index) in filteredHallintaSecondaryPages">
          <v-divider :key="index + 'secondary_divider'"></v-divider>
          <v-list-item
              :key="index + 'hallinta_secondary'"
              :to="{ name: page.link }"
              :value="$route.name === page.link"
              active-class="primary--text"
          >
            <v-badge v-if="page.items" :content="page.items" color="red"></v-badge>
            <v-list-item-action>
              <hb-icon>{{ page.icon }}</hb-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="body-2 font-weight-bold">{{ page.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-subheader v-if="!this.miniMenu">{{ $t('menu_sub_headers.jarjestelma') }}</v-subheader>
        <template>
          <hb-language-selector/>
        </template>
        <v-list-item :to="{ name: 'settings' }" :value="$route.name === 'settings'" active-class="primary--text" exact>
          <v-list-item-action>
            <v-icon>settings_applications</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">{{ $t('user_settings.title') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-for="(page, index) in filteredSystemPrimaryPages">
          <v-list-item
              :key="index + 'systemprimary'"
              :to="{ name: page.link }"
              :value="$route.name === page.link"
              active-class="primary--text"
          >
            <v-list-item-action>
              <v-badge v-if="page.items" :content="page.items" color="red"></v-badge>
              <hb-icon>{{ page.icon }}</hb-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="body-2 font-weight-bold">{{ page.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">{{ $t('logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div v-if="showHash" class="grey--text text--darken-1"
           style="position: absolute; left: 20px; right: 20px; bottom: 10px">
        Revision: #{{ hash }}
      </div>
    </v-navigation-drawer>

    <v-main>
      <router-view/>
    </v-main>
    <confirm-dialog ref="confirm"/>
  </v-app>
</template>

<script>
import auth from './auth';
import db from './database';
import UiEventBus from '@/UiEventBus';
import ConfirmDialog from "./components/ConfirmDialog";

export default {
  components: {ConfirmDialog},
  data() {
    return {
      color: '',
      text: '',
      buttonText: '',
      showButton: false,
      timeOut: -1,
      callback: () => {
      },
      snackbar: false,
      miniMenu: false,
      bottomNavSelected: '',
      showBottomNav: true,
      menuOpenState: false,
      selectedAddress: {},
      syncItems: 0,
    };
  },
  methods: {
    logout() {
      auth.client.logout();
    },
    goToLink(name) {
      this.$router.push({name: name});
    },
    toggleMiniMenu() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.miniMenu = !this.miniMenu;
      } else {
        this.$store.commit('toggleMainMenuState');
      }
    },
    handleSelectedBottomNavItem(name) {
      const isAsennustenhallintaPrimary = this.hallintaPages.findIndex(p => p.primary && p.link === name) > -1;
      const isStrategiaPrimary = this.strategiaPages.findIndex(p => p.primary && p.link === name) > -1;
      if (isAsennustenhallintaPrimary && isStrategiaPrimary) {
        this.bottomNavSelected = name;
        this.showBottomNav = true;
      } else {
        this.showBottomNav = false;
      }
    },
    async reloadDbItemCount() {
      this.syncItems = await db.itemCount();
    },
  },
  watch: {
    notificationObject(to) {
      this.color = to.color;
      this.text = to.message;
      this.snackbar = true;
      this.buttonText = to.buttonText;
      this.showButton = to.showButton;
      this.timeOut = to.timeOut;
      this.callback = to.callback;
    },
    menuOpenComputed(to) {
      this.menuOpenState = to;
    },
    menuOpenState(to) {
      if (to !== this.$store.state.mainMenuOpen) {
        this.$store.commit('toggleMainMenuState');
      }
    },
    selectedRoute(to) {
      this.handleSelectedBottomNavItem(to);
    },
    $route(to, from) {
      if (from && from.name) this.$store.commit('setPreviousRouteName', from.name);
    },
  },
  computed: {
    hallintaPages() {
      return [
        /*{
          title: this.$t('kuormitus.title'),
          icon: 'mdi mdi-chart-timeline',
          link: 'suunnittelu',
          permission: 'kehu.suunnittelu',
          primary: true,
        },*/
        {
          title: this.$tc('vastuualue.title', 2),
          link: 'asetukset_vastuualue',
          permission: this.$ADMIN_PERMISSION,
          primary: true,
          icon: 'mdi mdi-map-marker-account-outline'
        },
        {
          title: this.$tc('valinta.title', 2),
          link: 'asetukset_valinta',
          permission: this.$ADMIN_PERMISSION,
          primary: true,
          icon: 'mdi mdi-selection-multiple-marker'
        },
        {
          title: this.$tc('valintatyyppi.title', 2),
          link: 'asetukset_valintatyyppi',
          permission: this.$ADMIN_PERMISSION,
          primary: true,
          icon: 'mdi mdi-view-column-outline'
        },
        {
          title: this.$tc('henkilo.title', 2),
          link: 'asetukset_henkilot',
          permission: this.$ADMIN_PERMISSION,
          primary: true,
          icon: 'mdi mdi-account-multiple'
        },
      ];
    },
    strategiaPages() {
      return [
        {
          title: this.$t('henkilonakyma.title'),
          link: 'omat_tiedot',
          permission: null,
          primary: true,
          icon: 'mdi mdi-account'
        },
        {
          title: this.$t('strategia.title'),
          link: 'strategia',
          permission: null,
          primary: true,
          icon: 'mdi mdi-strategy'
        },

      ];
    },
    systemPages() {
      return [
        /*{
          title: this.$t('sync.menu_title'),
          icon: 'upload',
          link: 'sync',
          permission: null,
          items: this.syncItems,
          primary: true,
        },*/

      ];
    },
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    showHash() {
      return !(this.miniMenu && this.$vuetify.breakpoint.lgAndUp);
    },
    env() {
      return ENV_DESCRIPTION;
    },
    hash() {
      return COMMITHASH;
    },
    userFullName() {
      return `${this.$user.firstname} ${this.$user.lastname}`;
    },
    userEmail() {
      return this.$user.email;
    },
    notificationObject() {
      return this.$store.state.notificationObject;
    },
    menuOpenComputed() {
      let menuState = true;
      if (this.$vuetify.breakpoint.mdAndDown) {
        menuState = this.$store.state.mainMenuOpen;
      }
      return menuState;
    },
    filteredHallintaSecondaryPages() {
      let pages = [];
      this.hallintaPages.forEach(page => {
        if (!page.primary) {
          if (this.$hasPermission(page.permission)) {
            pages.push(page);
          }
        }
      });
      return pages;
    },
    filteredStrategiaPrimaryPages() {
      let pages = [];
      this.strategiaPages.forEach(page => {
        if (page.primary) {
          if (this.$hasPermission(page.permission)) {
            pages.push(page);
          }
        }
      });
      return pages;
    },
    filteredStrategiaSecondaryPages() {
      let pages = [];
      this.strategiaPages.forEach(page => {
        if (!page.primary) {
          if (this.$hasPermission(page.permission)) {
            pages.push(page);
          }
        }
      });
      return pages;
    },
    filteredHallintaPrimaryPages() {
      let pages = [];
      this.hallintaPages.forEach(page => {
        if (page.primary) {
          if (this.$hasPermission(page.permission)) {
            pages.push(page);
          }
        }
      });
      return pages;
    },
    filteredSystemPrimaryPages() {
      let pages = [];
      this.systemPages.forEach(page => {
        if (page.primary) {
          if (this.$hasPermission(page.permission)) {
            pages.push(page);
          }
        }
      });
      return pages;
    },
  },
  async mounted() {
    if (this.$vuetify.breakpoint.lgAndUp) this.menuOpenState = true;
    this.handleSelectedBottomNavItem(this.$route.name);
    this.reloadDbItemCount();
    UiEventBus.$on('synchronization-objects-changed', () => {
      this.reloadDbItemCount();
    });
    this.$root.$confirm = this.$refs.confirm.open;
  },
};
</script>

<style lang="scss">
@import './sass/commonstyles.scss';

.v-card {
  border-radius: 0 !important;
}

.topbar-search {
  .v-input__slot {
    padding: 0 !important;

    &:after {
      display: none;
    }
  }
}

.address-select {
  .v-select__selections {
    max-width: 90%;
  }
}
</style>
